<template>
	<valuation-layout>
		<valuation-model-stepper slot="stepper" :current-step="4" />
		<div slot="content">
			<payroll-proposal-form
				:form-fields="formFields"
				:value="formValue"
				@onChangeValue="formValue = $event"
				@infoClick="onInfoClick"
			/>
			{{ hasValidValue }} asasd
		</div>
		<payroll-proposal-description
			slot="description"
			:description="payrollBudget[selectedField.uuid]"
			:enable-save="hasValidValue"
			@saveClick="savePayroll"
		/>
	</valuation-layout>
</template>

<script>
import ValuationLayout from '@/modules/job-evaluation/components/supplies/valuation-model/commons/ValuationLayout';
import ValuationModelStepper
	from '@/modules/job-evaluation/components/supplies/valuation-model/valuation-model/ValuationModelStepper';
import PayrollProposalDescription
	from '@/modules/job-evaluation/components/supplies/valuation-model/valuation-model/payroll-proposal/payroll-proposal-description';
import PayrollProposalForm
	from '@/modules/job-evaluation/components/supplies/valuation-model/valuation-model/payroll-proposal/payroll-proposal-form';
import { mapState } from 'vuex';
import { head, isEmpty, isNil, pathOr, prop } from 'ramda';

export default {
	name: 'PayrollProposalPage',
	components: {
		PayrollProposalForm,
		PayrollProposalDescription,
		ValuationModelStepper,
		ValuationLayout,
	},
	data() {
		return {
			selectedField: {},
			formValue: {
				currentPayroll: undefined,
				idealPayroll: undefined,
			},
			formFields: [
				{
					name: 'PRESUPUESTO DE SU NOMINA ACTUAL',
					uuid: 'currentPayroll',
					descriptionId: 'currentPayrollDescription',
				},
				{
					name: 'PRESUPUESTO DE SU NOMINA IDEAL',
					uuid: 'idealPayroll',
					descriptionId: 'idealPayrollDescription',
				},
			],
		};
	},
	mounted() {
		this.selectedField = head(this.formFields) || {};
	},
	computed: {
		...mapState('jobEvaluation', {
			payrollBudget: pathOr({}, ['mainData', 'config', 'stages', 0, 'details', 2, 'payrollBudget']),
		}),
		hasValidValue() {
			const isValidValue = val => !isNil(val) && !isEmpty(val);
			const validateValue = key => isValidValue(prop(key, this.formValue));
			return validateValue('currentPayroll') && validateValue('idealPayroll');
		},
	},
	methods: {
		onInfoClick(field) {
			this.selectedField = field;
		},
		savePayroll() {
			this.$store.dispatch('jobEvaluation/savePayrollProposal', this.formValue)
				.then(() => {
					this.goTo('job-evaluation-supplies');
				})
				.catch(e => console.error(e));
		},
	},
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/modules/job-evaluation/pages/supplies/valuation-model/step-pages/PayrollProposalPage.vue